export interface State {
  isLoading: boolean;
  error?: any;
}

export const initialState: State = {
  isLoading: false,
  error: null,
};
